




















import Vue from 'vue'
import PopupMenu from '@/components/popupModel.vue'
import { mapState } from 'vuex'
import { MUTATIONS_ACTIONS, SettingParametersType } from '@/types'
export default Vue.extend({
  components: {
    PopupMenu
  },
  computed: {
    ...mapState({
      isPopOpen: 'isPopOpen',
      popupSrc: 'popupSrc'
    })
  },
  methods: {
    onPopupUpdate (output: SettingParametersType) {
      this.$store.commit(MUTATIONS_ACTIONS.SET_TAILWIND_CONFIG, output)
      this.$store.commit(MUTATIONS_ACTIONS.CLOSE_POPUP)
    },
    onPopupClose () {
      this.$store.commit(MUTATIONS_ACTIONS.CLOSE_POPUP)
    }
  }
})
